import React from 'react';
import Chart from 'chart.js';
import { Grid } from '@material-ui/core';
import useWindowDimensions from 'hooks/useWindowWidth';
import i18n from 'i18n';
import DashboardModalLegend from '../../../DashboardModalLegend';

interface DoughnutGraphProps {
  isModal?: boolean;
  values: any | undefined;
}

const DoughnutGraph = ({ isModal, values }: DoughnutGraphProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);

  const data = {
    labels: values?.map(item => i18n.t(item.label)),
    datasets: [
      {
        data: values?.map(item => item.count),
        backgroundColor: values?.map(item => item.color),
        hoverBackgroundColor: values?.map(item => item.color),
        borderColor: values?.map(item => item.color),
        borderWidth: 0.7,
        hoverOffset: 80,
      },
    ],
  };

  const config = {
    type: 'doughnut',
    data,
    options: {
      animation: false,
      legend: {
        display: false,
      },
      tooltips: {
        enabled: true,
      },
    },
  };

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  const { width } = useWindowDimensions();

  return isModal ? (
    <Grid container justify="flex-end" alignItems="center">
      <Grid item xs={5}>
        {values?.map((env, index) => (
          <DashboardModalLegend key={index} {...env} />
        ))}
      </Grid>
      <Grid item xs={7}>
        <canvas
          style={{ height: 160 }}
          ref={containerRef}
          width="100"
          height="100"
        ></canvas>
      </Grid>
    </Grid>
  ) : (
    <Grid container alignItems="center">
      {width < 1708 ? (
        <canvas ref={containerRef} width="130" height="130"></canvas>
      ) : (
        <Grid item style={{ width: 195 }}>
          <canvas ref={containerRef} width="195" height="auto"></canvas>
        </Grid>
      )}
    </Grid>
  );
};

export default DoughnutGraph;
